import Immutable from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import APP_SETTINGS from 'constants/appConfig'

// constants
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSED_NAV'
export const CHANGE_SIDEBAR_WIDTH = 'CHANGE_SIDEBAR_WIDTH'

// actions
export const toggleCollapsedNav = ActionHelper.createActionObj(
  TOGGLE_COLLAPSED_NAV,
)
export const changeSidebarWidth = ActionHelper.createActionObj(
  CHANGE_SIDEBAR_WIDTH,
)
// state
const initialState = Immutable.fromJS(APP_SETTINGS)

// reducers
const settings = handleActions(
  {
    [TOGGLE_COLLAPSED_NAV]: (state, action) =>
      state.setIn(['settings', 'navCollapsed'], action.payload),
    [CHANGE_SIDEBAR_WIDTH]: (state, action) =>
      state.setIn(['settings', 'sidebarWidth'], action.payload),
  },
  initialState,
)

export default settings
